module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('center', [(_vm.loaded == false) ? _c('img', {
    staticStyle: {
      "padding-top": "7%"
    },
    attrs: {
      "src": require("../../shared/assets/images/3dloader.gif")
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.loaded == true) ? _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [(_vm.rfcList != '' && _vm.search != '') ? _c('v-text-field', {
    attrs: {
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.rfcList != '' && _vm.search == '') ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.loaded == true) ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "pagination": _vm.pagination,
      "search": _vm.search,
      "items": _vm.rfcList,
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "7% "
          }
        }, [_vm._v(_vm._s(props.item.created.substr(0, 10)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "7%"
          }
        }, [_vm._v(_vm._s(_vm.fncGetRfcAge(props.item.created.substr(0, 10))))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "7%"
          }
        }, [_vm._v(_vm._s(props.item.number) + "." + _vm._s(props.item.version))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "8%"
          }
        }, [_vm._v(_vm._s(_vm.fncFilter(props.item.creditNoteNumber)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "8%"
          }
        }, [_vm._v(_vm._s(_vm.fncFilter(props.item.salesReturnNumber)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(props.item.originator.fullname))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(props.item.customer.fullname))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "11%"
          }
        }, [_vm._v(_vm._s(props.item.customer.company.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "11%"
          }
        }, [_vm._v(_vm._s(_vm.fncCheckDelivery(props.item.deliveryAddressId)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "5%"
          }
        }, [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncViewQuote(props.item.id, props.item.number, props.item.customer.id, props.item.customer.fullname, props.item.deliveryAddressId)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("line_style")])])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(props.item.statusDescription))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "6%"
          }
        }, [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncRfcStatus(props.item.id, props.item.number)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("alarm")])])])]
      }
    }], null, false, 1397186667)
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}